import React from "react"

export const CookieBanner = () => {
	return (
		<cookie-banner storage-key="psn-cookie-consent">
			<h2>Privacy Settings</h2>
			<p>
				This website uses cookies to improve your browsing experience and
				analyze site traffic. See our{" "}
				<a href="/privacy-policy">Privacy Policy</a> for more information.
			</p>
		</cookie-banner>
	)
}

export default CookieBanner
